import { Button, Menu } from "@overmap-ai/blocks"
import { memo, useCallback } from "react"

import { SelectItemTemplate } from "../../MenuGroups/constants"
import { defaultRowsPerPageOptions } from "../constants"

interface RowsPerPageSelectProps {
	selectedRowsPerPage: number
	onRowsPerPageChange: (rowsPerPage: number) => void
	rowsPerPageOptions?: number[]
}

export const RowsPerPageSelect = memo((props: RowsPerPageSelectProps) => {
	const { selectedRowsPerPage, rowsPerPageOptions = defaultRowsPerPageOptions, onRowsPerPageChange } = props

	const handleValueChange = useCallback(
		(rowsPerPageAsString: string) => {
			onRowsPerPageChange(parseInt(rowsPerPageAsString))
		},
		[onRowsPerPageChange],
	)

	return (
		<Menu.Root align="start">
			<Menu.ClickTrigger>
				<Button>{selectedRowsPerPage}</Button>
			</Menu.ClickTrigger>
			<Menu.Content size="sm">
				<Menu.SelectGroup
					required={true}
					value={selectedRowsPerPage.toString()}
					onValueChange={handleValueChange}
				>
					{rowsPerPageOptions.map((rowsPerPage) => (
						<SelectItemTemplate value={rowsPerPage.toString()} key={rowsPerPage} closeOnSelect>
							{rowsPerPage}
						</SelectItemTemplate>
					))}
				</Menu.SelectGroup>
			</Menu.Content>
		</Menu.Root>
	)
})
RowsPerPageSelect.displayName = "RowsPerPageSelect"
